'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ItemDetailMock = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _delay = require('./delay');

var _delay2 = _interopRequireDefault(_delay);

var _mockData = require('./mockData');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemDetailMock = exports.ItemDetailMock = {
    fetchItemDetailsByIds: function fetchItemDetailsByIds(itemIds) {
        return new _promise2.default(function (resolve) {
            setTimeout(function () {
                var itemDescriptions = itemIds.map(function (x) {
                    return (0, _mockData.getTestItemDetails)(x);
                });
                resolve({
                    data: {
                        data: itemDescriptions
                    }
                });
            }, _delay2.default);
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/mock/itemDetail.js
// module id = dekO
// module chunks = 46